import { INSTAGRAM } from '@app/constants/socialIntegrationsTypes';

// Те же признаки ссылки, что бэкенд проверяет при сохранении робота:
// http://, https://, www. без учёта регистра.
const COMMENT_REPLY_LINK_PATTERN = /(https?:\/\/|www\.)/i;

const COMMENT_REPLY_LINK_ERROR = 'Уберите ссылку из ответа под комментарием';

// Возвращает текст ошибки или null, если текст можно сохранить.
export const getCommentReplyTextError = (
  value: string | undefined
): string | null =>
  value && COMMENT_REPLY_LINK_PATTERN.test(value)
    ? COMMENT_REPLY_LINK_ERROR
    : null;

// Ответ под комментарием бэкенд принимает только для канала Instagram.
// Пустой текст и другой канал — ключ CommentReplyText не передаётся.
export const getCommentReplyTypeParameters = (
  commentReplyText: string | undefined,
  socialIntegrationType: string | undefined
): { CommentReplyText?: string } => {
  const trimmedText = commentReplyText?.trim();

  return socialIntegrationType === INSTAGRAM && trimmedText
    ? { CommentReplyText: trimmedText }
    : {};
};
